// extracted by mini-css-extract-plugin
module.exports = {"maximalMobileWidth":"580px","maximalTabletWidth":"1024px","selectWrap":"Select_selectWrap__2jhoz","select":"Select_select__2VA3G","item":"Select_item__2H5lq"};